"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDialog = void 0;
var react_1 = __importDefault(require("react"));
var dialogService_1 = require("../contexts/dialogService");
exports.useDialog = function () { return react_1.default.useContext(dialogService_1.DialogServiceContext); };
